/**
 * Expands and collapses line-limited rich text blocks.
 */
if (!customElements.get('rich-text-read-more')) {
  class RichTextReadMore extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.content = this.querySelector('[data-read-more-content]');
      this.toggle = this.querySelector('.rich-text--read-more-toggle');
      if (!this.content || !this.toggle) return;
      this.abortController = new AbortController();
      this.content.classList.toggle('rich-text--line-limit', this.toggle.getAttribute('aria-expanded') !== 'true');

      this.toggle.addEventListener('click', () => this.onToggle(), {
        signal: this.abortController.signal,
      });
      window.addEventListener('resize', () => this.checkOverflow(), {
        signal: this.abortController.signal,
      });

      this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this.resizeObserver.observe(this.content);
      requestAnimationFrame(() => { if (this.isConnected) this.checkOverflow(); });
    }

    checkOverflow() {
      if (this.toggle.getAttribute('aria-expanded') === 'true') return;

      const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
      this.classList.toggle('is-overflowing', overflowing);
      this.toggle.hidden = !overflowing;
    }

    onToggle() {
      const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';

      this.toggle.setAttribute('aria-expanded', String(!isExpanded));
      this.toggle.textContent = isExpanded ? this.toggle.dataset.showText : this.toggle.dataset.hideText;
      this.content.classList.toggle('rich-text--line-limit', isExpanded);
      if (isExpanded) this.checkOverflow();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('rich-text-read-more', RichTextReadMore);
}